import { isEmpty } from "lodash";

const useHideTeam = (team) => {
  if (isEmpty(team)) {
    return false;
  }

  return !team?.directMemberCount;
  // If someone tries to hide a group with child groups, the backend will return an appropriate error.
};

export default useHideTeam;
